/*MAIN COMPOMEMT */
import { addMinutes, format, parse, parseISO, startOfDay } from 'date-fns';
import {
  PhoneNumberFormat,
  PhoneNumberUtil
} from 'google-libphonenumber';
import Cookies from "js-cookie";
import 'react';

import * as XLSX from "xlsx";
import { ItemUser, MenuItem } from '../../resources/types';

import { globalStateStore } from '../context/GlobalStateContext';

export const setVersion = (id: string) => globalStateStore.setVersion?.(id) ?? localStorage.setItem('version', id.toString());
export const setLoading = (id: boolean) => globalStateStore.setLoading?.(id) ?? localStorage.setItem('loading', id.toString());
export const setJWT = (id: string) => globalStateStore.setJWT?.(id) ?? localStorage.setItem('JWT', id.toString());
export const setReturnUrl = (id: string) => globalStateStore.setReturnUrl?.(id) ?? localStorage.setItem('returnUrl', id.toString());
export const setIdUser = (id: number) => globalStateStore.setIdUser?.(id) ?? localStorage.setItem('idUser', id.toString());
export const setIdAirport = (id: number) => globalStateStore.setIdAirport?.(id) ?? localStorage.setItem('idAirport', id.toString());
export const setName = (id: string) => globalStateStore.setName?.(id) ?? localStorage.setItem('name', id.toString());
export const setUser = (id: string) => globalStateStore.setUser?.(id) ?? localStorage.setItem('user', id.toString());

export const setData = (value: Record<string, any> | ((prev: Record<string, any>) => Record<string, any>)) => {
  if (globalStateStore.setData) {
    globalStateStore.setData(value);
  } else {
    const current = JSON.parse(localStorage.getItem('data') || '{}');
    const next = typeof value === 'function' ? value(current) : value;
    localStorage.setItem('data', JSON.stringify(next));
  }
};
export const setParameters = (value: Record<string, any> | ((prev: Record<string, any>) => Record<string, any>)) => {
  if (globalStateStore.setParameters) {
    globalStateStore.setParameters(value);
  } else {
    const current = JSON.parse(localStorage.getItem('parameters') || '{}');
    const next = typeof value === 'function' ? value(current) : value;
    localStorage.setItem('parameters', JSON.stringify(next));
  }
};

export const setMenu = (
  value: MenuItem[] | ((prev: MenuItem[]) => MenuItem[])
) => {
  if (globalStateStore.setMenu) {
    globalStateStore.setMenu(value);
  } else {
    const currentRaw = localStorage.getItem('menu');
    const current: MenuItem[] = currentRaw ? JSON.parse(currentRaw) : [];
    const next = typeof value === 'function' ? value(current) : value;
    localStorage.setItem('menu', JSON.stringify(next));
  }
};

export const setCounters = (value: Record<string, any> | ((prev: Record<string, any>) => Record<string, any>)) => {
  if (globalStateStore.setCounters) {
    globalStateStore.setCounters(value);
  } else {
    const current = JSON.parse(localStorage.getItem('counters') || '{}');
    const next = typeof value === 'function' ? value(current) : value;
    localStorage.setItem('counters', JSON.stringify(next));
  }
};
export function normalizeDate(date: any) {
  if (date) {
    const [year, month, day] = date.split('-');
    return `${day}-${month}-${year}`;
  }
  return "";
}
export function formatBytes(bytes: number, decimals = 2): string {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  const value = parseFloat((bytes / Math.pow(k, i)).toFixed(decimals));
  return `${value} ${sizes[i]}`;
}
export function parseDotNetDate(jsonDate: { match: (arg0: RegExp) => string[]; }) {
  // Extract the number between parentheses
  if (jsonDate) {
    const timestamp = parseInt(jsonDate.match(/\d+/)[0], 10);
    return new Date(timestamp);
  }
  return ""
}
export function formatPhone(phone: any) {
  const phoneUtil = PhoneNumberUtil.getInstance();
  if (phone) {
    phone = phone.replace(/\D/g, '')
    if (phone && phone.length > 3) {
      if (phone == '56912345678') {
        return '+56 9 1234 5678';
      } else {
        try {
          const number = phoneUtil.parse('+' + phone.toString(), undefined); // No region for initial parse
          return phoneUtil.format(number, PhoneNumberFormat.INTERNATIONAL);
        } catch (error) {
          // If parsing fails, it's likely not a recognizable phone number format, return empty string
          return '';
        }
      }
    }
  }
  return '';
}
export function sanitizeNumber(value: any, decimals: number = 2) {
  if (!value) return "";

  // Replace comma with dot and remove invalid characters
  if (decimals === 0) {
    value = value.toString().replace(",", "").replace(".", "")
  } else {
    value = value.toString().replace(",", ".")
  }
  value = value.toString().replace(/[^0-9.]/g, '');

  // Allow only one decimal point
  const parts = value.split('.');
  if (parts.length > 2) {
    value = parts[0] + '.' + parts[1];
  }

  // Remove leading zeros from integer part
  if (parts[0]) {
    parts[0] = parts[0].replace(/^0+(?=\d)/, ''); // keep single 0 if number is 0
  }

  // Limit decimal digits
  if (parts[1]) {
    parts[1] = parts[1].substring(0, decimals);
  }

  return parts.join('.');
}

export function getUser(idUser: number, data: any) {
  if (data && data.users) {
    //const user = data.users.find((u: { idUser: number; }) => u.idUser === idUser);
    const user: ItemUser | undefined = data.users.find(
      (u: ItemUser) => u.idUser === idUser
    );
    return user; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}
export function getEquipment(idEquipment: number, data: any) {
  if (data && data.equipments) {
    const equipment = data.equipments.find((u: { idEquipment: number; }) => u.idEquipment === idEquipment);
    return equipment; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}

export function getCategory(idCategory: number, data: any) {
  if (data && data.categories) {
    const categories = data.categories.find((u: { idCategory: number; }) => u.idCategory === idCategory);
    return categories; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}


export function getDelt(idBelt: number, data: any) {
  if (data && data.belts) {
    const belts = data.belts.find((u: { idBelt: number; }) => u.idBelt === idBelt);
    return belts; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}

export function getGate(idGate: number, data: any) {
  if (data && data.gates) {
    const gates = data.gates.find((u: { idGate: number; }) => u.idGate === idGate);
    return gates; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}
export function getBelt(idBelt: number, data: any) {
  if (data && data.belts) {
    const belts = data.belts.find((u: { idBelt: number; }) => u.idBelt === idBelt);
    return belts; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}
export function getAirport(idAirport: number, data: any) {
  if (data && data.airports) {
    const airports = data.airports.find((u: { idAirport: number; }) => u.idAirport === idAirport);
    return airports; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}
export function getStatus(idStatus: number, data: any) {
  if (data && data.statuses) {
    const statuses = data.statuses.find((u: { idStatus: number; }) => u.idStatus === idStatus);
    return statuses; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}
export function getAirline(idAirline: number, data: any) {
  if (data && data.airlines) {
    const airlines = data.airlines.find((u: { idAirline: number; }) => u.idAirline === idAirline);
    return airlines; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}



export function getGroupType(idGroupType: number, data: any) {
  if (data && data.equipments) {
    const groupTypes = data.groupTypes.find((u: { idGroupType: number; }) => u.idGroupType === idGroupType);
    return groupTypes; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}
export function getUserType(idUserType: number, data: any) {
  if (data && data.usersTypes) {
    const userType = data.usersTypes.find((u: { idUserType: number; }) => u.idUserType === idUserType);
    return userType; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}
//const { JWT, setJWT } = useGlobalState(); const { serverVersion, setServerVersion } = useGlobalState();
export function storeCounters(data: any, setInvoicesExpired: (invoicesExpired: number) => void, setPendingAuth: (pendingAuth: number) => void, setShowPropertiesSelector: (token: number) => void) {
  if (data && data.admin && data.admin.properties) {
    setShowPropertiesSelector(data.admin.properties.length)
  }
  if (data && data.admin && data.admin.counters) {
    setInvoicesExpired(data.admin.counters.invoicesExpired)
    setPendingAuth(data.admin.counters.pendingAuth)
  }
}

export function storeJWT(
  data: any) {


  /*
  if (data?.JWT) {
    setJWT(data.JWT);
    localStorage.setItem("JWT", data.JWT);
  }
    */
  if (data?.idUser) {

    setIdUser(data.idUser);
    localStorage.setItem("idUser", data.idUser);
  }
  if (data?.name) {
    setName(data.name);
    localStorage.setItem("name", data.name);
  }
  if (data && data?.version) {
    setVersion(data.version)
  }

  if (data && data.admin && data.admin.menu) {
    setMenu(data.admin.menu)
  }

  if (data?.menu && typeof setMenu === 'function') {
    //setMenu(data.menu);
    //localStorage.setItem("menu", JSON.stringify(data.menu));
  }
}
/*
export function storeJWT2(data: any, setJWT: (token: string) => void, setServerVersion: (token: number) => void, setMenu: (token: any) => void) {
  if (data?.JWT && data?.JWTRenew && data.JWTRenew !== "") {
    console.log("token set:", data.JWTRenew);
    if (data && data.admin && data.admin.counters) {
      console.log(data.admin.counters)
      //const { setPendingAuth } = useGlobalState();
      //setPendingAuth(data.admin.counters.pendingAuth);
      localStorage.setItem('pendingAuth', data.admin.counters.pendingAuth.toString());
      localStorage.setItem('invoicesExpired', data.admin.counters.invoicesExpired.toString());
    }
    setJWT(data.JWTRenew);
  }
  console.log(data.serverVersion)
  if (data && data?.serverVersion) {
    setServerVersion(data.serverVersion)
  }
  if (data && data.admin && data.admin.menu) {
    setMenu(data.admin.menu)
  }
}
  */
export function isEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function getParameter(hash: string, parameter: string) {
  let queryParams = new URLSearchParams();
  let hashNow = hash.substring(1);
  let extractedReturnUrl = ''
  const questionMarkIndex = window.location.hash.indexOf('?');
  if (questionMarkIndex !== -1) {
    if (parameter === "") {
      let rt = hash.substring(questionMarkIndex + 1);

    } else {
      hashNow = hashNow.substring(0, questionMarkIndex - 1);
      let queryString = hash.substring(questionMarkIndex + 1);
      queryParams = new URLSearchParams(queryString);
      extractedReturnUrl = queryParams.get(parameter) || '';
    }
  }
  return extractedReturnUrl;
}
export function hideKeyboardGlobally() {
  const activeElement = document.activeElement;

  if (activeElement) {
    setTimeout(() => {
      console.log("Blur...");
      //alert("BLUR");
      (activeElement as HTMLElement).blur();
    }, 500)
  }
}
export function getHash(hash: string) {

  let hashNow = hash.substring(1);
  const questionMarkIndex = window.location.hash.indexOf('?');
  let queryString = '';
  let queryParams = new URLSearchParams();
  let rUrl: string | null = '';
  if (questionMarkIndex !== -1) {

    hashNow = hash.substring(0, questionMarkIndex);
    queryString = hash.substring(questionMarkIndex + 1);
    queryParams = new URLSearchParams(queryString);
    const extractedReturnUrl = queryParams.get('returnUrl');
    rUrl = extractedReturnUrl;
  }
  return hashNow;
}
export function isValidPhone(phone: any) {
  const phoneUtil = PhoneNumberUtil.getInstance();
  if (phone) {
    phone = phone.replace(/\D/g, '')
    if (phone.length > 3) {
      if (phone == '56912345678') {
        return true;
      } else {
        try {
          const number = phoneUtil.parse('+' + phone.toString(), undefined); // No region for initial parse
          return (phoneUtil.isValidNumber(number)); // Check if it's a possible number for any region
        } catch (error) {
          // If parsing fails, it's likely not a recognizable phone number format, keep disabled
          return false;
        }
      }
    }
  }
  return false;
}
export const fileToBase64 = (file: File): Promise<{ base64: string; file: File }> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    // When the file reading is complete
    reader.onload = () => {
      // The result will be a data URL (e.g., "data:image/png;base64,iVB...")
      // We strip the header (e.g., "data:image/png;base64,") to get pure Base64
      const base64String = reader.result ? (reader.result as string).split(',')[1] : '';
      resolve({ base64: base64String, file });
    };

    // Handle errors during reading
    reader.onerror = (error) => reject(error);

    // Read the file content as a Data URL (which contains Base64)
    reader.readAsDataURL(file);
  });
};

export function isJWTExpired(token: string): boolean {
  if (!token) return true; // No token = expired

  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const decodedPayload = JSON.parse(atob(base64));

    if (!decodedPayload.exp) {
      return true; // No exp = consider expired
    }
    //const date = new Date(decodedPayload.exp * 1000);
    //console.log(date)
    const now = Math.floor(Date.now() / 1000); // Current time in seconds
    return decodedPayload.exp < now;
  } catch (error) {
    console.error('Failed to decode JWT:', error);
    return true; // Invalid token = expired
  }
}

type Currency = "CLP" | "UF" | string;

export function formatCurrency(
  value: number,
  currency: any
): string {


  let minimumFractionDigits = 2;
  let crr = currency
  if (typeof crr === "number") {
    minimumFractionDigits = currency;
    crr = "CLP"
  } else {
    crr = currency
    if (currency === "UF") {
      minimumFractionDigits = 2;
    } else if (currency === "CLP") {
      minimumFractionDigits = 0;
    }
  }


  return new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: crr,
    minimumFractionDigits,
    maximumFractionDigits: minimumFractionDigits,
  }).format(value);
}

/*
export function formatDate(dateString: string): string {
  if (dateString !== '') {
    try {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
      const year = date.getFullYear();
      console.log(dateString)
      console.log(day)
      return `${day}-${month}-${year}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  } else { return '' }
}
  */
export function formatDate(dateString: string): string {
  if (dateString !== '') {
    try {
      const date = parseISO(dateString);
      const formattedDate = format(date, 'dd-MM-yyyy');
      //console.log(dateString);
      //console.log(format(date, 'dd'));
      return formattedDate;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  } else {
    return '';
  }
}
export function minutesToHHMM(minutes: number): string {
  const baseTime = startOfDay(new Date()); // 00:00 today
  const time = addMinutes(baseTime, minutes);
  return format(time, "H'H' mm'M'");
}
export function minutesToHHMM2(minutes: number): string {
  // 1. Calculate the total number of hours (can be > 24)
  const totalHours = Math.floor(minutes / 60);

  // 2. Calculate the remaining minutes (0-59)
  const remainingMinutes = minutes % 60;

  // 3. Format hours and minutes with leading zeros (e.g., 9 becomes "09")
  const formattedHours = String(totalHours).padStart(totalHours < 100 ? 2 : totalHours < 1000 ? 3 : 4, '0');
  const formattedMinutes = String(remainingMinutes).padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}`;
}

export function setCookie(name: string, value: string, days = 7) {
  Cookies.set(name, value, {
    expires: days, // cookie expiration in days
    path: "/",     // available on all paths
    sameSite: "strict"
  });
}

// ✅ Get a cookie
export function getCookie(name: string): string {
  return Cookies.get(name) || "";
}

// ✅ Remove a cookie
export function removeCookie(name: string) {
  Cookies.remove(name, { path: "/" });
}

// ✅ Update cookie (just call setCookie again)
export function updateCookie(name: string, value: string, days = 7) {
  setCookie(name, value, days);
}
export function getToday() {
  const today = new Date();
  return today.setHours(0, 0, 0, 0); // reset to midnight
}

export function findBreadcrumbPath(
  items: MenuItem[],
  currentHash: string,
  parents: MenuItem[] = []
): MenuItem[] | null {
  for (const item of items) {
    if (item.href === currentHash) {
      return [...parents, item]; // found exact match
    }

    if (item.items && item.items.length > 0) {
      const found = findBreadcrumbPath(item.items, currentHash, [...parents, item]);
      if (found) return found;
    }
  }
  return null;
}
export function buildBreadcrumbItems(menu: MenuItem[]) {
  // Ensure current hash always starts with '#'
  const currentHash =
    (window.location.hash.startsWith('#')
      ? window.location.hash
      : `#${window.location.hash}`).split('?')[0]; // ignore query params

  const path = findBreadcrumbPath(menu, currentHash);

  // Always start with "Inicio"
  const breadcrumbs = [
    { text: "Inicio", href: "#home" },
    ...(path
      ? path.map(item => {
        // Use item.href if available, otherwise build fallback
        const href = item.href && item.href.trim() !== ""
          ? item.href
          : window.location.hash;
        //`${item.section?.toLowerCase().replace(/\s+/g, '-')}/default2
        return { text: item.text, href };
      })
      : []),
  ];

  return breadcrumbs;
}

export function stripHtml(html: string): string {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
}

export function getTipoDTE(TipoDTE: number) {
  switch (TipoDTE) {
    case 33:
      return { label: "Factura Electrónica", shortLabel: "Factura", color: "blue", value: "33" };
    case 34:
      return { label: "Factura No Afecta o Exenta Electrónica", shortLabel: "Factura Exenta", color: "cyan", value: "34" };
    case 43:
      return { label: "Liquidación-Factura Electrónica", shortLabel: "Liquidación", color: "purple", value: "43" };
    case 46:
      return { label: "Factura de Compra Electrónica", shortLabel: "Factura de Compra", color: "orange", value: "46" };
    case 52:
      return { label: "Guía de Despacho Electrónica", shortLabel: "Guía de Despacho", color: "lightgreen", value: "52" };
    case 56:
      return { label: "Nota de Débito Electrónica", shortLabel: "Nota de Débito", color: "red", value: "56" };
    case 61:
      return { label: "Nota de Crédito Electrónica", shortLabel: "Nota de Crédito", color: "green", value: "61" };
    case 110:
      return { label: "Factura de Exportación", shortLabel: "Factura Exportación", color: "blue", value: "110" };
    case 111:
      return { label: "Nota de Débito de Exportación", shortLabel: "Nota Débito Exportación", color: "red", value: "111" };
    case 112:
      return { label: "Nota de Crédito de Exportación", shortLabel: "Nota Crédito Exportación", color: "green", value: "112" };
    case 0:
      return { label: "Desconocido", shortLabel: "Desconocido", color: "grey", value: TipoDTE.toString() };
    default:
      return { label: "Desconocido", shortLabel: "Desconocido", color: "grey", value: TipoDTE.toString() };
  }
}

export function base64Encode(str: any) {
  try {
    // 1. Convert the string to a sequence of bytes (Uint8Array)
    const bytes = new TextEncoder().encode(str);
    // 2. Convert the byte sequence to a binary string
    const binary = String.fromCodePoint(...bytes);
    // 3. Encode the binary string to Base64
    return btoa(binary);
  } catch (e) {
    console.error("Encoding failed:", e);
    return '';
  }
};

export function base64Decode(b64: string): string {
  try {
    const binary = atob(b64);

    // Convert binary string to a Uint8Array of byte codes
    const bytes = Uint8Array.from(binary, c => c.codePointAt(0) || 0);

    // Decode the bytes back to a regular string
    const decodedString = new TextDecoder().decode(bytes); // ⬅️ The final result

    return decodedString; // ⬅️ RETURN ADDED HERE

  } catch (e) {
    console.error("Decoding failed:", e);
    return ''; // Return an empty string on error
  }
};

export function exportToExcel(data: any, name: string = "export.xls", sheet: string = "Hoja 1") {
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheet);
    XLSX.writeFile(wb, `${name}.xlsx`);
  };
  exportToExcel();
}

export function isMobileDevice() {
  if (typeof window !== 'undefined') {
    // Se utiliza 'navigator.userAgent' y 'navigator.vendor' que son tipados.
    // Para 'window.opera', se accede a través de 'window as any' para evitar el error de TS,
    // ya que no es una propiedad estándar del objeto Window.
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    // 1. Detección de dispositivos Android, iOS y Windows Phone
    if (/android/i.test(userAgent)) {
      return true;
    }

    // 2. Detección de iOS (iPad, iPhone, iPod)
    // Se corrige el error de tipado accediendo a window.MSStream con 'window as any'.
    // Nota: A partir de iOS 13, iPad puede reportar un User-Agent de escritorio 
    // pero mantiene un toque táctil. 'MacIntel' y 'maxTouchPoints' es la forma moderna de detectar iPads.
    if (/iPad|iPhone|iPod/.test(userAgent) && !((window as any).MSStream)) {
      return true;
    }

    // 3. Detección general de sistemas operativos móviles (BlackBerry, Windows Phone, etc.)
    if (/Mobi|Tablet|Mobile|Windows Phone|IEMobile|BlackBerry|Opera Mini/i.test(userAgent)) {
      return true;
    }

    // 4. Detección moderna para tablets (como iPad en modo escritorio)
    // Verifica si el dispositivo es macOS/Intel pero tiene capacidad táctil
    if (
      navigator.platform === 'MacIntel' &&
      typeof navigator.maxTouchPoints === 'number' &&
      navigator.maxTouchPoints > 2
    ) {
      return true;
    }
  }
  return false;
}


export const resizeBase64Image = (
  base64: string,
  maxSize: number,
  quality: number = 0.7
): Promise<string> => {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      const { width, height } = img;

      // Determine which side is larger
      const isWidthLarger = width >= height;

      // Compute proportional dimensions
      let targetWidth: number;
      let targetHeight: number;

      if (isWidthLarger) {
        const ratio = maxSize / width;
        targetWidth = maxSize;
        targetHeight = height * ratio;
      } else {
        const ratio = maxSize / height;
        targetHeight = maxSize;
        targetWidth = width * ratio;
      }

      const canvas = document.createElement("canvas");
      canvas.width = targetWidth;
      canvas.height = targetHeight;

      const ctx = canvas.getContext("2d");
      if (!ctx) return reject("Canvas not supported");

      ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

      resolve(canvas.toDataURL("image/jpeg", quality));
    };

    img.onerror = reject;
    img.src = base64;
  });
};
function generateRandomLettersString(N: number): string {
  // Define the characters (A-Z and a-z)
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  let result = '';

  // Get the length of the character set
  const charactersLength = characters.length;

  for (let i = 0; i < N; i++) {
    // Generate a random index within the length of the character set
    const randomIndex = Math.floor(Math.random() * charactersLength);

    // Append the character at the random index to the result
    result += characters.charAt(randomIndex);
  }

  return result;
}


export function saveMasters(data: any, dataTemp: any) {
  if (data.masters && dataTemp) {
    if (data.masters.airlines) { dataTemp.airlines = data.masters.airlines; }
    if (data.masters.airports) { dataTemp.airports = data.masters.airports; }
    if (data.masters.userAirports) { dataTemp.userAirports = data.masters.userAirports; }
    if (data.masters.belts) { dataTemp.belts = data.masters.belts; }
    if (data.masters.gates) { dataTemp.gates = data.masters.gates; }
    if (data.masters.statuses) { dataTemp.statuses = data.masters.statuses; }
    if (data.masters.displays) { dataTemp.displays = data.masters.displays; }
    if (data.masters.counters) { dataTemp.counters = data.masters.counters; }
  }
  if (data.userAirports && dataTemp) {
    dataTemp.userAirports = data.userAirports;
  }
  localStorage.setItem("data", JSON.stringify(dataTemp))

  console.log("DATA.SET")
  return dataTemp;
}



export function getDate(dateTimeString: string): string {
  if (!dateTimeString)
    return "";
  try {
    return format(parse(dateTimeString, 'dd-MM-yyyy HH:mm', new Date()), 'dd-MM-yyyy');
  } catch (error) {
    return "";
  }
}
export function getTime(dateTimeString: string): string {
  if (!dateTimeString)
    return "";
  try {
    return format(parse(dateTimeString, 'dd-MM-yyyy HH:mm', new Date()), 'HH:mm');
  } catch (error) {
    return "";
  }
}
export function addNotification(
  content: string,
  type: "info" | "success" | "warning" | "error" = "info",
  setData: (callback: (prevData: any) => any) => void
) {
  if (!content) return;

  const duration = 10000; // 10 seconds
  const id = Date.now().toString() + Math.random().toString(36).substring(2, 7);
  const expiresAt = Date.now() + duration; // Calculate the end time

  const rawNotification = { id, content, type, expiresAt };

  setData((prevData: any) => {
    const currentNotifications = type === "error" ? [] : (prevData?.notifications || []);
    const newData = {
      ...prevData,
      notifications: [rawNotification, ...currentNotifications].slice(0, 5)
    };
    localStorage.setItem("data", JSON.stringify(newData));
    return newData;
  });

  // Automatic removal
  setTimeout(() => {
    setData((prevData: any) => {
      const updatedNotifications = (prevData?.notifications || []).filter((n: any) => n.id !== id);
      const updatedData = { ...prevData, notifications: updatedNotifications };
      localStorage.setItem("data", JSON.stringify(updatedData));
      return updatedData;
    });
  }, duration);
}

export function clearNotifications(
  setData: (callback: (prevData: any) => any) => void
) {
  setData((prevData: any) => {
    const newData = {
      ...prevData,
      notifications: [] // Reset to empty array
    };

    // Sync with localStorage so they don't reappear on refresh
    localStorage.setItem("data", JSON.stringify(newData));

    return newData;
  });
}

export function getUrlVersion() {
  if (window.location.host.includes("localhost") || window.location.host.includes("[::1]"))
    return "https://fidsqa.agunsa.com/v7";
  else if (window.location.host.includes("fids.agunsa.com"))
    return "https://fids.agunsa.com/v7";
  else
    return "https://fidsqa.agunsa.com/v7";

}